/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl, checkIsActive } from '../../../../_helpers'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import DescriptionIcon from '@material-ui/icons/Description';
import LanguageIcon from '@material-ui/icons/Language';
import { shallowEqual, useSelector } from 'react-redux'
import { AccountBalance, GroupWork, HomeWork, Person, Public, CalendarToday } from '@material-ui/icons'
import { therapistIsVerified } from '../../../../../utils/auth'

export function AsideMenuList({ layoutProps }) {
	const user = useSelector((store) => store.authentication?.user, shallowEqual)
	const location = useLocation()
	const getMenuItemActive = (url, hasSubmenu = false) => {
		return checkIsActive(location, url)
			? ` ${!hasSubmenu &&
          'menu-item-active'} menu-item-open menu-item-not-hightlighted`
			: ''
	}

	if (!therapistIsVerified(user))
	return (<>
		<ul className={`menu-nav ${layoutProps.ulClasses}`}>
			<li
				className={`menu-item ${getMenuItemActive('/dashboard', false)}`}
				aria-haspopup="true"
			>
				<NavLink className="menu-link" to="/dashboard">
					<span className="svg-icon menu-icon">
						<SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')} />
					</span>
					<span className="menu-text">Dashboard</span>
				</NavLink>
			</li>
		</ul>
	</>)

	return (
		<>
			{/* begin::Menu Nav */}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				<li className="menu-section">
					<h4 className="menu-text">USUARIOS</h4>
					<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
				</li>
				{user.isAdmin && <>
					<li
						className={`menu-item ${getMenuItemActive('/admins', false)} ${getMenuItemActive('/edit-admin', false)}`}
						aria-haspopup="true"
					>
						<NavLink className="menu-link" to="/admins">
							<span className="menu-icon">
								<AssignmentIndIcon/>
							</span>
							<span className="menu-text">Administradores</span>
						</NavLink>
					</li>
					<li
						className={`menu-item ${getMenuItemActive('/therapists', false)} ${getMenuItemActive('/edit-therapist', false)}`}
						aria-haspopup="true"
					>
						<NavLink className="menu-link" to="/therapists">
							<span className="menu-icon">
								<Person/>
							</span>
							<span className="menu-text">Terapeutas</span>
						</NavLink>
					</li>
				</>}
				<li
					className={`menu-item ${getMenuItemActive('/clients', false)} ${getMenuItemActive('/edit-client', false)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/clients">
						<span className="menu-icon">
							<Person/>
						</span>
						<span className="menu-text">Clientes</span>
					</NavLink>
				</li>
				{user.isTherapist && (
					<li
						className={`menu-item ${getMenuItemActive('/my-schedule', false)}`}
						aria-haspopup="true"
					>
						<NavLink className="menu-link" to="/my-schedule">
							<span className="menu-icon">
								<CalendarToday/>
							</span>
							<span className="menu-text">Mi horario</span>
						</NavLink>
					</li>
				)}

				{ user.isAdmin && (
				<>
					<li className='menu-section'>
						<h4 className='menu-text'>GESTIÓN</h4>
						<i className='menu-icon ki ki-bold-more-hor icon-md'></i>
					</li>
					<li
						className={`menu-item ${getMenuItemActive('/centers', false)} ${getMenuItemActive('/edit-center', false)}`}
						aria-haspopup="true"
					>
						<NavLink className="menu-link" to="/centers">
							<span className="menu-icon">
								<HomeWork/>
							</span>
							<span className="menu-text">Centros</span>
						</NavLink>
					</li>
					<li
						className={`menu-item ${getMenuItemActive('/therapeutic-groups', false)} ${getMenuItemActive('/edit-therapeutic-group', false)}`}
						aria-haspopup="true"
					>
						<NavLink className="menu-link" to="/therapeutic-groups">
							<span className="menu-icon">
								<GroupWork/>
							</span>
							<span className="menu-text">Grupos terapéuticos</span>
						</NavLink>
					</li>
					{/* <li
						className={`menu-item ${getMenuItemActive('/calendar?refresh=true', false)} `}
						aria-haspopup="true"
					>
						<NavLink className="menu-link" to="/calendar?refresh=true">
							<span className="menu-icon">
								<CalendarToday/>
							</span>
							<span className="menu-text">Calendar</span>
						</NavLink>
					</li> */}
				</>
				)}

				{user.isAdmin && (
					<>
						<li className='menu-section'>
							<h4 className='menu-text'>MISCELÁNEA</h4>
							<i className='menu-icon ki ki-bold-more-hor icon-md'></i>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/countries',
								false
							)} ${getMenuItemActive('/edit-country', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/countries'>
								<span className='menu-icon'>
									<Public />
								</span>
								<span className='menu-text'>Países</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/provinces',
								false
							)} ${getMenuItemActive('/edit-province', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/provinces'>
								<span className='menu-icon'>
									<Public />
								</span>
								<span className='menu-text'>Provincias</span>
							</NavLink>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								'/cities',
								false
							)} ${getMenuItemActive('/edit-city', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/cities'>
								<span className='menu-icon'>
									<Public />
								</span>
								<span className='menu-text'>Ciudades</span>
							</NavLink>
						</li>
						{/* <li
							className={`menu-item ${getMenuItemActive(
								'/languages',
								false
							)} ${getMenuItemActive('/edit-language', false)}`}
							aria-haspopup='true'>
							<NavLink className='menu-link' to='/languages'>
								<span className='menu-icon'>
									<LanguageIcon />
								</span>
								<span className='menu-text'>Lenguajes</span>
							</NavLink>
						</li> */}
						<li
							className={`menu-item ${getMenuItemActive('/texts', false)} ${getMenuItemActive('/edit-text', false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/texts">
								<span className="menu-icon">
									<DescriptionIcon/>
								</span>
								<span className="menu-text">Textos</span>
							</NavLink>
						</li>
					</>
				)}
			</ul>

			{/* end::Menu Nav */}
		</>
	)
}
